import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import DeleteModal from "components/Common/DeleteModal"
import ShipmentListComponent from "components/Shipment/list"
import {
  deleteShipment,
  exportShipments,
  getShipments,
} from "store/shipment/shipment-action"

const ShipmentList = () => {
  const dispatch = useDispatch()
  const { data, loading, exportStatus } = useSelector(state => state.shipment)
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })

  const handleDeleteFunc = () => {
    if (selectedRecord) {
      dispatch(deleteShipment(selectedRecord.id))
    }
    setDeleteModal(false)
  }

  const onClickDelete = data => {
    setSelectedRecord(data)
    setDeleteModal(true)
  }

  const onPageClick = link => {
    dispatch(getShipments(link.url, pageNumber, according, search))
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      dispatch(getShipments(undefined, undefined, undefined, search))
    }, 1500)

    return () => clearTimeout(delayDebounceFn)
  }, [dispatch, search])

  useEffect(() => {
    dispatch(getShipments(undefined, pageNumber, according, search))
  }, [dispatch, pageNumber, according, search])

  return (
    <>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteFunc}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Breadcrumbs title={"Admin"} breadcrumbItem={"Shipments"} />
      <ShipmentListComponent
        data={data}
        loading={loading}
        onClickDelete={onClickDelete}
        onPageClick={onPageClick}
        onSearch={setSearch}
        onChangeRowNumber={setPageNumber}
        onChangeOrdering={value => {
          if (value.order) {
            setAccording(prev => ({ ...prev, order: value.order }))
          }
          if (value.name) {
            setAccording(prev => ({ ...prev, name: value.name }))
          }
        }}
        onExportBtnClick={() => dispatch(exportShipments(search))}
        exportStatus={exportStatus}
      />
    </>
  )
}

export default ShipmentList
